/* @generated */

// src/assets/ui-icon/line/activity.tsx
import * as React from "react";
var ActivityLine = (props) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", ...props }, /* @__PURE__ */ React.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m10.11 8.536-1.547 3.251a1.25 1.25 0 0 1-1.129.713H4V11h3.276l2.025-4.251c.39-.819 1.58-.738 1.856.127l2.625 8.25 1.143-3.287a1.25 1.25 0 0 1 1.18-.839H20v1.5h-3.717l-1.578 4.537c-.316.908-1.606.89-1.897-.025L10.11 8.536Z",
    fill: "currentColor",
    vectorEffect: "non-scaling-stroke"
  }
));
export {
  ActivityLine
};
